'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var WidgetUi = (0, _immutable.Record)({
  mobile: false,
  open: false,
  hideWelcomeMessage: false,
  domain: null,
  startOpen: undefined,
  url: null,
  userInteractedWithWidget: false,
  isEmbeddedInProduct: false,
  mode: null
}, 'WidgetUi');

exports.default = WidgetUi;
module.exports = exports['default'];